// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 Ben Richardson — https://benrichardson.dev
// Additional terms under AGPL-3.0 section 7(b) apply; see ADDITIONAL-TERMS.md.

/** Small, pure platform probes so behaviour can be tested without a device. */

/**
 * iPhone/iPod only (NOT iPad, which routes to the loudspeaker). While a mic
 * MediaStream is live, iOS routes AudioContext output to the earpiece and no web
 * API can move it — so reference-tone playback while tuning needs a note.
 */
export function isIPhone(userAgent: string): boolean {
  return /\b(iPhone|iPod)\b/.test(userAgent);
}

/** Whether the mic could plausibly be used here (secure context + the API). */
export function micAvailable(): boolean {
  return (
    typeof window !== 'undefined' &&
    window.isSecureContext === true &&
    typeof navigator !== 'undefined' &&
    !!navigator.mediaDevices?.getUserMedia
  );
}
